import React, { Fragment, useContext, useEffect, useState } from "react";
import { Link, useHistory } from 'react-router-dom';
import Button from '../../lib/ui/buttons/Button';
import { LangCtx } from "../../lib/context";
import OtpInput from 'react-otp-input';
import "../../layouts/Layouts.css";
import { Auth } from "aws-amplify";

const VerifyAccount = (props) => {
    const history = useHistory();
    const { l } = useContext(LangCtx);
    const [code, setCode] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [counter, setCounter] = useState(120);

    useEffect(() => {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }, [counter]);

    const handleVerify = (e) => {
        e.preventDefault();
        try {
            if (code === '') {
                setErrorMsg(l.pls_ent_verifi_code)
            } else if (code.length !== 6) {
                setErrorMsg(l.pls_ent_valid_code)
            } else {
                let username = props.location.search.split("=")[1] || "";
                Auth.confirmSignUp(decodeURIComponent(username), code)
                    .then(data => {
                        setErrorMsg('')
                        history.push('/');
                    })
                    .catch(err => {
                         setErrorMsg(err.message)
                    });
            }
        } catch (e) {
            console.log("Error", e);
            setErrorMsg(l.went_worng_pls_try_again)
        }
    }

    const handleRensendCode = () => {
        let username = props.location.search.split("=")[1] || "";
        Auth.resendSignUp(decodeURIComponent(username))
            .then(res => {
                if (res){
                    setCounter(120);
                    setErrorMsg('')
                }
            })
            .catch(err => {
                 setErrorMsg(err.message)
            });
    }

    return <Fragment>
        <div className="coverContainer">
            <div className="outSideContainer">
                <div className="colCredential mrgnVAuto">
                    <div className="bodyRow fullHightJC">
                        <div className="crdRowBlock justifyCenter">
                            <h2 className="headingTxt">{l.vfy_acct}</h2>
                        </div>
                        <div className="crdRowBlock">
                            <p className="pTxt txtCenter">{l.vfy_msg}</p>
                        </div>
                        <div className="crdFormBlock">
                            {errorMsg && errorMsg !== "" && <div className="errorBox">
                                <small className="errorTxt">{errorMsg}</small>
                            </div>
                            }
                            <form id="forgotform" onSubmit={handleVerify} autoComplete="off">
                                <div className="colBlock">
                                    <small className="inpLabel">{l.vfy_code}<span className="redTxt">*</span>:</small>
                                    <OtpInput className="otpInput"
                                        value={code}
                                        onChange={setCode}
                                        numInputs={6}
                                        // separator={<span>-</span>}
                                        containerStyle={{flex:1, width:"100%"}}
                                        focusStyle= {{borderColor: "#24a4c4"}}
                                        // inputStyle={{width:"14%"}}
                                    />
                                    <div className="crdBtnContainer">
                                        <Button onClick={handleVerify}
                                            label={l.vfy}
                                            type='primary'
                                            size='md'
                                            buttonType="submit"
                                            fullWidth="fullWidth"
                                        />
                                    </div>
                                </div>
                            </form>
                            <div className="rowSpaceBtwn mrgTop24">
                                {counter > 0 ? <p className="pTxt">{l.resend_otp} after <span className="linkTxt redTxt">{counter + ' s'}</span></p>
                                    : 
                                    <Link to={`/verify-account?phone=${props.location.search.split("=")[1]}`} onClick={handleRensendCode} className="linkTxt">{l.resend_otp}</Link>}
                            </div>
                            <div className="crdRowBlock mrgTop24">
                                <Link to="/" className="fullTxtLink">
                                    <span>{l.backtologin}</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
}

export default VerifyAccount;
